import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import NtmTrace from '../../../components/NtmTraceData';
import { callStatisticsMock } from './mock';
import { createHealthHistory } from './mocks';

const styles = () => ({
  title: {
    display: 'block',
  },
  card: {
    overflowX: 'auto',
  },
  active: {
    color: '#1682bc',
    '&:hover': {
      backgroundColor: '#ddd',
    },
  },
});

const networkOptions = [
  {
    description: 'Iristest',
    code: 'iristest.comcast.com',
  },
  {
    description: 'Cox',
    code: 'cox.comcast.com',
  },

  {
    description: 'XfinityVoice',
    code: 'xfinityvoice.comcast.com',
  },
];

class NtmTraceContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      searchValues: {
        selectedDomain: 'iristest.comcast.com',
        phoneNumber: '',
        startTime: '',
        endTime: '',
      },
      isDateFilterOpen: false,
    };
    this.handleChangeOperator = this.handleChangeOperator.bind(this);
    this.handleClickTimeFilterBtn = this.handleClickTimeFilterBtn.bind(this);
    this.getTransformedData = this.getTransformedData.bind(this);
    this.onClickDateFilter = this.onClickDateFilter.bind(this);
  }

  componentWillMount() {
    const { searchValues } = this.state;
    searchValues.startTime = new Date().getTime() - 24 * 60 * 60 * 1000;
    searchValues.endTime = new Date().getTime();
    this.setState({ searchValues });
  }

  getTooltipData = (d) => {
    const date = d.time_bucket;
    const futureDate = new Date(date.getTime() + (120 * 60000));
    const parsedDate = `${(`0${date.getMonth() + 1}`).slice(-2)}/${
      (`0${date.getDate()}`).slice(-2)}/${
      date.getFullYear()} ${
      (`0${date.getHours()}`).slice(-2)}:${
      (`0${date.getMinutes()}`).slice(-2)} - ${
      (`0${futureDate.getHours()}`).slice(-2)}:${
      (`0${futureDate.getMinutes()}`).slice(-2)} GMT-0400 (Eastern Time)`;
    const tooltipHtml = `
    <div> Call Connected at: ${parsedDate}</div>
    `;
    return tooltipHtml;
  }

  getBarColors = (value) => {
    if (value === 0) {
      return '#DC2620';
    }
    if (value === 1) {
      return '#86C35D';
    }

    return '#FF9E00';
  }

  getTransformedData = (records) => {
    const interval = 120;
    const totalRecords = records.length ? records : [];
    const healthHistory = createHealthHistory(interval);
    for (let i = 0; i < totalRecords.length; i++) {
      const thisTime = new Date(totalRecords[i].time_bucket);
      const bucket = new Date(Math.floor(thisTime.getTime() / (interval * 60000)) * (interval * 60000));
      if (totalRecords[i].time_bucket > healthHistory[0].time_bucket.toISOString()) {
        healthHistory.find(v => v.time_bucket.toString() === bucket.toString()).avg = totalRecords[i].avg;
      }
    }
    const transformedRecords = healthHistory;
    transformedRecords.sort((a, b) => {
      a = new Date(a.time_bucket);
      b = new Date(b.time_bucket);
      return a > b ? 1 : a < b ? -1 : 0;
    });
    return transformedRecords;
  }

  onClickDateFilter = (dateFilters) => {
    let { searchValues } = this.state;
    searchValues = Object.assign(searchValues, dateFilters);
    this.setState({ searchValues });
  }

  handleChangeOperator = (selectedOption) => {
    const { searchValues } = this.state;
    searchValues.selectedDomain = selectedOption.code;
    this.setState({ searchValues });
  }

  onSearchNtmEventsByTraceId = (value) => {
    const { searchValues } = this.state;

    const values = { ...searchValues };

    const trace = value;
    values.traceId = trace;

    this.setState({ searchValues: values });
  }

  handleClickTimeFilterBtn(status) {
    const { isDateFilterOpen } = this.state;
    if (status !== undefined && status !== isDateFilterOpen) {
      this.setState({ isDateFilterOpen: status });
    }
  }

  render() {
    const { classes } = this.props;
    const { isDateFilterOpen, searchValues } = this.state;
    return (
      <div>
        <NtmTrace
          ntmDetailsData={this.ntmDetailsData}
          getTooltipData={this.getTooltipData}
          getBarColors={this.getBarColors}
          networkOptions={networkOptions}
          handleChangeOperator={this.handleChangeOperator}
          onClickDateFilter={this.onClickDateFilter}
          handleClickTimeFilterBtn={this.handleClickTimeFilterBtn}
          isDateFilterOpen={isDateFilterOpen}
          onSearchNtmEventsByTraceId={this.onSearchNtmEventsByTraceId}
          searchValues={searchValues}
          getTransformedData={this.getTransformedData}
        />
      </div>
    );
  }
}


export default withStyles(styles)(NtmTraceContainer);
